import React from "react";
import logo from "./images/logo.png";

export default function Header2() {
  return (
    <div
      style={{
        position: "sticky",
        top: "0px",
        zIndex: 3,
        // padding: "10px",
        boxSizing: "border-box",
        // backgroundColor: "white",
      }}>
      {" "}
      <nav
        id="header2"
        className="d-flex justify-content-between py-1 px-2 bg-light">
        <div id="logo">
          <a href="/">
            <img src={logo} alt="" className="py-2" />
          </a>
        </div>
        <div id="navbar1">
          <ul className="list-unstyled d-flex gap-3 py-2 ">
            <li>
              <button className="btn btn-light text-success ">Home</button>
            </li>
            <li>
              <button className="btn btn-light">About</button>
            </li>
            <li>
              <div className="btn-group p-1">
                <button
                  className="btn btn-light btn-sm dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  id="Events">
                  Events
                </button>
                <ul className="dropdown-menu border-0">
                  <li className="py-2 li-Hover">
                    <a href="/">Events-Lists</a>
                  </li>
                  <li className="py-2 li-Hover">
                    <a href="/">Events-Details</a>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <div className="btn-group p-1">
                <button
                  className="btn btn-light btn-sm dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false">
                  Blogs
                </button>
                <ul className="dropdown-menu p-2 py-2 border-0">
                  <li className="py-2 li-Hover">
                    <a href="/">Blog-Grid</a>
                  </li>
                  <li className="py-2 li-Hover">
                    <a href="/">Blog-Details</a>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <div className="btn-group p-1">
                <button
                  className="btn btn-light btn-sm dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false">
                  Pages
                </button>
                <ul className="dropdown-menu p-2 border-0">
                  <li className="py-1 li-Hover">
                    <a href="/">FAQ</a>
                  </li>
                  <li className="py-1 li-Hover">
                    <a href="/">MY ACCOUNT</a>
                  </li>
                  <li className="py-1 li-Hover">
                    <a href="/">SIGN IN</a>
                  </li>
                  <li className="py-1 li-Hover">
                    <a href="/">SIGN UP</a>
                  </li>
                  <li className="py-1 li-Hover">
                    <a href="/">OTP</a>
                  </li>
                  <li className="py-1 li-Hover">
                    <a href="/">MY ACCOUNT</a>
                  </li>
                  <li className="py-1 li-Hover">
                    <a href="/">PAYMENT OPTION</a>
                  </li>
                  <li className="py-1 li-Hover">
                    <a href="/">PAYMENT INFORMATION</a>
                  </li>
                  <li className="py-1 li-Hover">
                    <a href="/">PRIVACY & POLICIES</a>
                  </li>
                  <li className="py-1 li-Hover">
                    <a href="/">TERMS & CONDITIONS</a>
                  </li>
                  <li className="py-1 li-Hover">
                    <a href="mailto:saadmukhtar584@gmail.com">CONTACT</a>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <button className="btn btn-light">Contact</button>
            </li>
            <li>
              <a href="/">
                <i className="fa-solid fa-magnifying-glass text-black pt-3" />
              </a>
            </li>
          </ul>
        </div>
        <div id="navbar2">
          <ul className="list-unstyled d-flex gap-3 py-2 ">
            <li>
            <>
  <p>
    <button
      className="border-0"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#collapseWidthExample"
      aria-expanded="false"
      aria-controls="collapseWidthExample"
      
    >
     <i className="fa-solid fa-magnifying-glass fs-4 mt-2 " />
    </button>
  </p>
  <div>
    <div className="collapse collapse-horizontal" id="collapseWidthExample">
      <div className="card card-body d-flex justify-content-center align-items-center gap-1" style={{ width: 300 }}>
      <input type="text" placeholder="Search Here" className="w-100"/>
      <button className="btn btn-success w-50 ">Search</button>
      <span className="text-success"> Press Search icon to close</span>

      </div>
    </div>
  </div>
</>
            </li>
            <li>
              <div className="dropdown">
                <button
                  className="btn btn-light dropdown"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false">
                  <i className="fa-solid fa-bars fs-4 " />{" "}
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <a className="dropdown-item " href="/">
                      Home
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item " href="/">
                      About{" "}
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item li-hover" href="/">
                      Blogs{" "}
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/">
                      Pages{" "}
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/">
                      Contact Us{" "}
                    </a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
}

